import { useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import styled from "styled-components";
import img from "../images/1.png";
import request from "../api"


const DetailFeedScreenRelatedVideo = ({ video }) => {
  const navigate = useNavigate();
  const id = video?.id?.videoId
  const _channelId = video?.id?.channelId

  const dispatch = useDispatch();
  const [channelIcon, setChannelIcon] = useState(null)

  useEffect(() => {
    const get_channel_icon = async () => {
       const {
          data: { items },
       } = await request('/channels', {
          params: {
             part: 'snippet',
             id: _channelId,
          },
       })
       setChannelIcon(items[0].snippet.thumbnails.default.url)
    }
    get_channel_icon()
 }, [_channelId, id])

  const handlee = () => {
    navigate(`/details/${id}`);
    console.log("clciked")
  };
  return (
  <>
    <Main >
      <div className="Img" onClick={handlee}>
        <img src={video?.snippet?.thumbnails?.high?.url}  />
      </div>
      <span className="time-stamp">5:00</span>
      <div className="left">
        <p className="text1">{video?.snippet?.title}</p>
        <p>13m views . 2 days ago</p>
        <div className="subcribe">
          <Img2>
            <img src={channelIcon} />
          </Img2>
          <div>
            <span>{video?.snippet?.channelTitle}</span>
          </div>
        </div>
      </div>
    </Main>
  </>
  );
};

export default DetailFeedScreenRelatedVideo;

const Main = styled.div`
  width: 100%;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 5px;
  .Img {
    width: 50%;
    height: 15vh;
    display: grid;
    place-items: center;
    margin-left: 5px;
    cursor: pointer;
    img {
      width: 100%;
      position: relative;
    }
  }
  .subcribe {
    display: flex;
    align-items: center;
  }
  .text1 {
    font-size: 9px;
    cursor: pointer;
  }
  .left {
    width: 50%;
    padding-left: 2px;
  }
  .time-stamp {
    position: absolute;
    background-color: black;
    padding: 2px 8px;
    color: white;
    margin-right: 30px;
    margin-top: 85px;
  }
`;

const Img = styled.div`
  width: 100%;
  overflow: hidden;
  height: 50vh;
  display: grid;
  place-items: center;
  position: relative;
  img {
    width: 100%;
    cursor: pointer;
  }
`;
const Img2 = styled.div`
  width: auto;
  img {
    width: 20px;
    height: 20px;
    border-radius: 50%;
  }
`;